import feedback from './feedback';
import report from './report';
import goldCoin from './goldCoin';
import ranking from './giftRank';
import coinMerchant from './coinMerchant';
import recharge from './recharge';
import familyTask from './familyTask';
import luckyGiftList from './luckyGiftList';
import familyList from './familyList';
import totalRank from './totalRank';
import level from './haloLevel';
import userLevel from './userLevel';
import global from './global';
import diamondFlow from './diamondFlow';
import newTaskCenter from './newTaskCenter';
import giftList from './giftList';
import cpList from './cpList';
import dreamCityNew from './dreamCityNew';
import rechargeEvent from './rechargeEvent';
import luckyDraw from './luckyDarw';
import anchorPK from './anchorPK';
import luckyRankVs from './luckyRankVs';
import activityBiuBiuBuilding from './activityBiuBiuBuilding';
import activityAnnualRanking from './activityAnnualRanking';
import achorRank from './achorRank';
import lasserBairam from './lasserBairam';
import RamadanNewActivity from './RamadanNewActivity';
import topGame from './topGame';
import springFestivalCP from './springFestivalCP';
import anniversaryCelebration2Activity from './anniversaryCelebration2Activity';
import fishingActivity from './fishingActivity';
import hungryGhostActivity from './hungryGhostActivity';
import speedPassion from './speedPassion';
import activityCrazyBuilder from './activityCrazyBuilder';
import activityGameKing from './activityGameKing';
import activityJungleExpedition from './activityJungleExpedition';
import activityFestivalOfSacrifice from './activityFestivalOfSacrifice';
import luckyDrawMay from './luckyDrawMay';
import coinsBattle from './coinsBattle';
import luckyRecharge from './luckyRecharge';
import gameCenterList from './gameCenterList';
import airWallex from './airWallex';
import mpesa from './mpesa';
import airtel from './airtel';
import receiveList from './receiveList';
import withdraw from './withdraw';
import withdrawBind from './withdrawBind';
import giftWall from './giftWall';
import curAristocracyModel from './curAristocracyModel';
import vipPrivileges from './vipPrivileges';
import myEarning from './myEarning';
import share from './share';
import totalRankAll from './totalRankVoice';
import newUserRewards from './newUserRewards';
import help from './help';
import tvWall from './tvWall';
import incomeRules from './incomeRules';
import specialRecharge from './specialRecharge';

const models = [
  global,
  feedback,
  specialRecharge,
  report,
  goldCoin,
  ranking,
  coinMerchant,
  recharge,
  totalRank,
  familyTask,
  luckyGiftList,
  familyList,
  level,
  userLevel,
  diamondFlow,
  newTaskCenter,
  airtel,
  withdraw,
  withdrawBind,
  giftWall,
  curAristocracyModel,
  vipPrivileges,
  myEarning,
  share,
  totalRankAll,
  newUserRewards,
  help,
  tvWall,
  incomeRules,
  receiveList,
  giftList,
  cpList,
  dreamCityNew,
  rechargeEvent,
  luckyDraw,
  anchorPK,
  luckyRankVs,
  activityBiuBiuBuilding,
  activityAnnualRanking,
  achorRank,
  lasserBairam,
  RamadanNewActivity,
  topGame,
  springFestivalCP,
  anniversaryCelebration2Activity,
  fishingActivity,
  hungryGhostActivity,
  speedPassion,
  activityCrazyBuilder,
  activityGameKing,
  activityJungleExpedition,
  activityFestivalOfSacrifice,
  luckyDrawMay,
  coinsBattle,
  luckyRecharge,
  gameCenterList,
  airWallex,
  mpesa,
];

export default models;
